export class GlobalConstants {
    public static googleGTAG: string = "G-3VWG1JRSJC";
}